<script>
    import AppHead from "./AppHead.svelte";
    import SeeDetails from "./SeeDetails.svelte";
    import Gallery from "../components/Gallery.svelte";
    import AppStore from "./LinkToAppStore.svelte";
    import { ddwItems, puzzleItems, diceItems } from "./projects-data";
</script>

<div style="height:40px;" />

<AppHead
    name="Daily Decision Wheel"
    icon="images/app_icon_ddw.png"
    detail="Complex parts: 60 fps spin + particle effects, share wheel with other users via link" />
<Gallery items={ddwItems} />
<SeeDetails
    appStoreLink="https://apps.apple.com/us/app/daily-decision-wheel/id1434195334"
    playStoreLink="https://play.google.com/store/apps/details?id=ru.epicapp.wheel&pcampaignid=epicapp-site" />

<AppHead
    name="Daily Jigsaw Puzzle"
    icon="images/app_icon_puzzle.png"
    detail="Complex parts: modular puzzle engine, smooth animations, subscription monetization" />
<Gallery items={puzzleItems} />
<SeeDetails
    appStoreLink="https://apps.apple.com/us/app/daily-jigsaw-puzzles/id1450295584" />

<AppHead
    name="Dice X"
    icon="images/app_icon_dice_x.png"
    detail="Complex parts: native 3d (scene kit), real world physics" />
<Gallery items={diceItems} />
<SeeDetails
    appStoreLink="https://apps.apple.com/us/app/dice-x-3d-dice-roller/id1190158236" />

<AppHead
    name="AmBa Transport"
    icon="images/app_icon_amba_transport.png"
    detail="Complex parts: developed for toddlers, series of games" />
<div style="display:flex; align-items:center; margin:10px;">
    <iframe
        title="Video Preview"
        style="margin:auto;"
        width="560"
        height="315"
        src="https://www.youtube.com/embed/CYb52swHUzE"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen />
</div>
<SeeDetails
    appStoreLink="https://apps.apple.com/us/app/cars-planes-ships-puzzle-games-for-toddlers-amba/id1249712065" />

<div style="height:40px;" />

<AppStore />

<div style="height:90px;" />
